
import { EarlyAccessLead, EarlyAccessStats } from '@/types/early-access';

export const calculateStats = (data: EarlyAccessLead[]): EarlyAccessStats => {
  const today = new Date();
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startOfWeek = new Date(startOfToday);
  startOfWeek.setDate(startOfToday.getDate() - startOfToday.getDay());

  const todayCount = data.filter(lead => 
    new Date(lead.created_at) >= startOfToday
  ).length;

  const weekCount = data.filter(lead => 
    new Date(lead.created_at) >= startOfWeek
  ).length;

  const interviewCount = data.filter(lead => 
    lead.interview_interest === "Yes, I'm interested"
  ).length;

  return {
    total: data.length,
    today: todayCount,
    thisWeek: weekCount,
    interviewInterested: interviewCount
  };
};
